import { useMsal } from "@azure/msal-react";
import { appConfig } from "@/config/appConfig";

/**
 * Replaces the hard-coded "Shaheen C." stub when MSAL is active. Reads the active account from
 * MSAL context and renders initials + name + a Sign out button. Falls back to the stub when
 * MSAL is disabled so dev mode keeps working.
 */
export function UserMenu() {
  if (appConfig.msal.disabled) {
    return (
      <div className="user">
        <div className="avatar">SC</div>
        <span>Shaheen C.</span>
      </div>
    );
  }
  return <SignedInUserMenu />;
}

function SignedInUserMenu() {
  const { instance, accounts } = useMsal();
  const account = accounts[0] ?? instance.getActiveAccount() ?? null;
  if (!account) return null;
  const name = account.name ?? account.username;
  const initials = computeInitials(name);
  return (
    <div className="user">
      <div className="avatar" aria-hidden="true">
        {initials}
      </div>
      <span title={account.username}>{name}</span>
      <button
        type="button"
        className="btn btn-ghost"
        style={{ padding: "2px 8px", fontSize: 12 }}
        onClick={() =>
          instance.logoutRedirect({ postLogoutRedirectUri: window.location.origin })
        }
      >
        Sign out
      </button>
    </div>
  );
}

function computeInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  const first = parts[0]!;
  if (parts.length === 1) return first.slice(0, 2).toUpperCase();
  const last = parts[parts.length - 1]!;
  return ((first[0] ?? "") + (last[0] ?? "")).toUpperCase();
}
